import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { Location } from 'history';
import b from 'b_';

import './datasets-page.css';

import PageMeta from '@components/page-meta';
import PaginationMeta from '@interfaces/pagination-meta';
import { PaginationWrapperProps } from '@components/pagination-wrapper';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';
import { Dataset } from '@interfaces/outreach-entity';
import { AsyncFetchDataProps } from '@interfaces/async-fetch-data';
import { formatQuery, parseQuery } from 'client/helpers/url';
import DatasetItem from '@components/dataset-item';
import ShowMore from '@components/pagination-wrapper/show-more';
import { fetchDatasets, fetchDatasetsFilters } from 'client/ducks/datasets-page/actions';
import DatasetsPageStub from 'pages/datasets-page/datasets-page-stub';
import YearFilter from '@components/year-filter/year-filter';

import outreachConfig from '../outreach/page-config.json';

export interface DispatchProps {
    fetchDatasets(params: OutreachRequestParams): void;
    fetchFilters(): void;
}

interface StateProps {
    hasMore: boolean;
    years: number[];
    rows: Dataset[];
    meta: PaginationMeta;
    listParams: OutreachRequestParams;
    isLoading: boolean;
}

export type Props = StateProps & DispatchProps & PaginationWrapperProps & RouteComponentProps<any>;

const class_ = b.with('datasets-page');

export default class DatasetsPage extends Component<Props> {
    public static asyncFetchData({ dispatch, location }: AsyncFetchDataProps) {
        const params = DatasetsPage.getRequestParams(location);

        dispatch(fetchDatasets(params));
        dispatch(fetchDatasetsFilters());
    }

    public static getRequestParams(location: Location, page = 1): OutreachRequestParams {
        const query = parseQuery(location.search);
        const year = query.get('year');
        const params: OutreachRequestParams = { page };

        if (year) {
            params.year = parseInt(year, 10);
        }

        return params;
    }

    public componentDidMount() {
        const { rows, years, location, listParams } = this.props;
        const currentParams = DatasetsPage.getRequestParams(location);

        if (!rows.length || (listParams.year !== currentParams.year)) {
            this.fetchDatasets();
        }

        if (!years.length) {
            this.props.fetchFilters();
        }
    }

    public fetchDatasets(params: OutreachRequestParams = {}) {
        const { location } = this.props;
        const currentParams = DatasetsPage.getRequestParams(location);

        this.props.fetchDatasets({ ...currentParams, ...params });
    }

    public onShowMoreClick = () => {
        const { meta } = this.props;
        const { pageNumber } = meta;

        this.fetchDatasets({ page: 1 + pageNumber });
    };

    public onYearChange = (year: number | undefined) => {
        const query = formatQuery({ year });

        this.fetchDatasets({ year });
        this.props.history.push(`/datasets${query}`);
    };

    public renderList() {
        const { rows, hasMore } = this.props;

        return (
            <div className={class_('list')} key="list">
                {rows.map(dataset =>
                    <DatasetItem
                        type="horizontal"
                        key={dataset.id}
                        entity={dataset}
                    />
                )}
                {hasMore && (
                    <ShowMore onClick={this.onShowMoreClick} />
                )}
            </div>
        );
    }

    public render() {
        const { years, rows, isLoading, location } = this.props;
        const query = parseQuery(location.search);
        const year = query.get('year') || undefined;

        return (
            <div className={class_()}>
                <PageMeta title="Datasets" description={outreachConfig.meta.description} />
                <div className={class_('top')}>
                    <h1 className="block__title">
                        Datasets
                    </h1>
                    {years.length > 1 && (
                        <YearFilter
                            years={years}
                            selectedYear={year}
                            onYearChange={this.onYearChange}
                        />
                    )}
                </div>

                {isLoading && !rows.length
                    ? <DatasetsPageStub key="stub" />
                    : this.renderList()
                }
            </div>
        );
    }
}
